<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-box" class="q-mb-sm" /> {{ $t('photo_types') }}
        </div>

        <div class="row gutter-sm">
            <div class="col-xs-12 col-sm-12">
                <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input type="number" v-model="points" :float-label="$t('points')" :error="$v.points.$error" @input="$v.points.$touch" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('image') }}</p>

                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="true" :aspect_ratio="512/512" :aspect_ratio_string="'512/512'" />

                <p v-if="image" class="q-mt-md file-url">
                    <q-icon name="fal fa-check" color="positive" />
                    <a :href="image" target="_blank"> {{ $truncateLink(image) }}</a>
                </p>
            </div>
        </div>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'photo_types' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'training', 'admin', 'rewards'] },

    data() {
        return {
            id: '',
            points: '',
            title: '',
            image: ''
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        fetchData() {
            this.$axios.get(`/admin_rewards/reward_upload_file_types/${this.id}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.points = response.data.points
                this.image = response.data.image
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data ={
                    title: this.title,
                    points: this.points,
                    image: this.image
                }

                if (this.id !== 0) {
                    this.$axios.put(`/admin_rewards/reward_upload_file_types/${this.id}/`, data, this.getHeader)
                    .then(response => {
                        this.$router.push({ name: 'photo_types' })
                    })
                    .catch(e => {     
                        console.log(e)
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
                else {
                    this.$axios.post('/admin_rewards/reward_upload_file_types/', data, this.getHeader)
                    .then(response => {
                        this.$router.push({ name: 'photo_types' })
                    })
                    .catch(e => {
                        console.log(e)
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        imageUploaded(url) {
            this.image = url
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        }
    },

    created() {
        this.id = this.$route.params.id
        if (this.id !== 0) this.fetchData()
    },

    validations() {
        return {
            title: { required },
            points: { required }
        }
    }
}
</script>

<style>

</style>
